import { NoParamEndpointConstructor, SingleParamEndpointConstructor } from 'interfaces/api.interfaces'

const baseUrl = '/groups'
const permissionsUrl = '/permissions'

interface Endpoints {
  getAll: NoParamEndpointConstructor
  getSingle: SingleParamEndpointConstructor
  create: NoParamEndpointConstructor
  update: SingleParamEndpointConstructor
  remove: SingleParamEndpointConstructor
  getAllPermissions: NoParamEndpointConstructor
  getGroupPermissions: SingleParamEndpointConstructor
  updateGroupPermissions: SingleParamEndpointConstructor
}

export const groupsEndpoints: Endpoints = {
  getAll: () => `${baseUrl}`,
  getSingle: (id) => `${baseUrl}/${id}`,
  create: () => `${baseUrl}`,
  update: (id) => `${baseUrl}/${id}`,
  remove: (id) => `${baseUrl}/${id}`,
  getAllPermissions: () => `${permissionsUrl}`,
  getGroupPermissions: (id) => `${baseUrl}/${id}${permissionsUrl}`,
  updateGroupPermissions: (id) => `${baseUrl}/${id}${permissionsUrl}`,
}
